(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["storage-bike-interactive"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = scope => {
    scope.querySelectorAll('[data-storage-bikes]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const choices = [...root.querySelectorAll('[data-bike-select]')];
      const panels = [...root.querySelectorAll('[data-bike-panel]')];
      const triggers = [...root.querySelectorAll('[data-bike-trigger]')];
      const stage = root.querySelector('.storage-bikes__stage');
      const wheelieButton = root.querySelector('.storage-bikes__wheelie');
      const status = root.querySelector('[data-bike-status]');
      const hint = root.querySelector('[data-bike-hint]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let animationFrame;
      const stop = () => { cancelAnimationFrame(animationFrame); root.classList.remove('is-wheelie'); };
      const wheelie = () => {
        if (root.classList.contains('is-hovering')) return;
        stop();
        if (motion.matches) return;
        animationFrame = requestAnimationFrame(() => {
          animationFrame = requestAnimationFrame(() => root.classList.add('is-wheelie'));
        });
      };
      const updateMotion = () => {
        stop();
        root.classList.remove('is-hovering');
        triggers.forEach(button => { button.disabled = motion.matches; });
        if (wheelieButton) wheelieButton.hidden = motion.matches;
        if (hint) hint.textContent = motion.matches ? root.dataset.staticHint : root.dataset.hint;
      };
      choices.forEach(choice => {
        choice.disabled = false;
        choice.addEventListener('click', () => {
          const color = choice.dataset.bikeSelect;
          const name = choice.dataset.colorName;
          root.dataset.color = color;
          choices.forEach(button => button.setAttribute('aria-pressed', String(button === choice)));
          panels.forEach(panel => { panel.hidden = panel.dataset.bikePanel !== color; });
          if (status) status.textContent = root.dataset.statusTemplate.replace('__COLOR__', name);
          if (stage) stage.setAttribute('aria-label', root.dataset.wheelieTemplate.replace('__COLOR__', name));
          wheelie();
        });
      });
      triggers.forEach(button => button.addEventListener('click', wheelie));
      if (stage) {
        stage.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && !motion.matches) { stop(); root.classList.add('is-hovering'); } });
        stage.addEventListener('pointerleave', () => root.classList.remove('is-hovering'));
      }
      root.addEventListener('animationend', event => { if (event.animationName === 'storage-bike-wheelie') root.classList.remove('is-wheelie'); });
      motion.addEventListener('change', updateMotion);
      document.addEventListener('visibilitychange', () => { if (document.hidden) { stop(); root.classList.remove('is-hovering'); } });
      updateMotion();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["storage-chrome-surface"] && !Shopify.designMode) return;
  try {
    (() => {
  const surface = document.querySelector('[data-storage-chrome]');
  const video = surface?.querySelector('[data-chrome-video]');
  if (!video) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection;
  let failed = false;
  let waiting = false;
  const sync = () => {
    document.body.classList.toggle('chrome-page-hidden', document.hidden);
    if (failed || reduced.matches || connection?.saveData || document.hidden) {
      video.pause();
      if (reduced.matches || connection?.saveData || failed) delete surface.dataset.chromePlaying;
      return;
    }
    if (waiting || !video.paused) return;
    if (!video.getAttribute('src')) video.src = video.dataset.src;
    video.muted = true;
    video.defaultMuted = true;
    waiting = true;
    const attempt = video.play();
    if (attempt?.then) attempt.then(() => {
      waiting = false;
      if (document.hidden || reduced.matches || connection?.saveData) sync();
    }).catch(() => {
      waiting = false;
      delete surface.dataset.chromePlaying;
    });
    else waiting = false;
  };
  video.addEventListener('playing', () => {
    if (reduced.matches || connection?.saveData || document.hidden) { sync(); return; }
    surface.dataset.chromePlaying = 'true';
  });
  video.addEventListener('error', () => { failed = true; sync(); });
  reduced.addEventListener('change', sync);
  connection?.addEventListener('change', sync);
  document.addEventListener('visibilitychange', sync);
  window.addEventListener('pageshow', sync);
  window.addEventListener('pagehide', () => video.pause());
  document.addEventListener('pointerdown', sync, { passive: true, once: true });
  // The still paints first; video never blocks the page or replaces product media.
  window.requestAnimationFrame(() => window.requestAnimationFrame(sync));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["storage-drop-rail"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = scope => scope.querySelectorAll('[data-storage-rail]').forEach(root => {
    if (root.dataset.initialized) return;
    const pieces = [...root.querySelectorAll('[data-rail-select]')];
    if (!pieces.length) return;
    const details = [...root.querySelectorAll('[data-rail-detail]')];
    const stage = root.querySelector('[data-rail-stage]');
    const status = root.querySelector('[data-rail-status]');
    const mobile = window.matchMedia('(max-width: 749px)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let selected = 0;
    let scrollFrame;
    const position = () => {
      const width = stage.clientWidth;
      const pieceWidth = window.innerWidth < 990 ? 360 : 420;
      const travel = Math.max(0, width - pieceWidth - 20);
      pieces.forEach((piece, index) => {
        const active = index === selected;
        const side = index < selected ? 1 : -1;
        const x = pieces.length > 1 ? (index / (pieces.length - 1) - .5) * travel : 0;
        piece.style.setProperty('--rail-x', `${x}px`);
        piece.style.setProperty('--rail-y', active ? '0px' : '8px');
        piece.style.setProperty('--rail-angle', mobile.matches || active ? '0deg' : `${side * 38}deg`);
        piece.style.setProperty('--rail-scale', active || mobile.matches ? '1' : '.76');
        piece.style.setProperty('--rail-z', active ? '5' : '1');
        piece.style.setProperty('--rail-opacity', active || mobile.matches ? '1' : '.76');
        piece.setAttribute('aria-pressed', String(active));
      });
    };
    const select = (index, announce = true) => {
      selected = (index + pieces.length) % pieces.length;
      details.forEach(detail => { detail.hidden = detail.dataset.railDetail !== pieces[selected].dataset.railSelect; });
      if (status && announce) status.textContent = root.dataset.statusTemplate.replace('__PIECE__', pieces[selected].dataset.pieceName).replace('__NUMBER__', String(selected + 1));
      position();
    };
    const setFace = (piece, face) => { piece.dataset.face = face; };
    pieces.forEach((piece, index) => {
      piece.dataset.face = piece.dataset.face || 'back';
      piece.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse' || mobile.matches) return;
        select(index);
      });
      let pointerFrame;
      let pointerX;
      piece.addEventListener('pointermove', event => {
        if (event.pointerType !== 'mouse' || mobile.matches) return;
        pointerX = event.clientX;
        if (pointerFrame) return;
        pointerFrame = requestAnimationFrame(() => {
          pointerFrame = 0;
          if (selected !== index) select(index);
          const rect = piece.getBoundingClientRect();
          const relative = (pointerX - rect.left) / rect.width;
          if (relative < .42) setFace(piece, 'front');
          else if (relative > .58) setFace(piece, 'back');
          if (!reduced.matches) piece.style.setProperty('--rail-tilt', `${(relative - .5) * 3}deg`);
        });
      }, { passive: true });
      piece.addEventListener('pointerleave', () => {
        cancelAnimationFrame(pointerFrame);
        pointerFrame = 0;
        piece.style.setProperty('--rail-tilt', '0deg');
      });
      piece.addEventListener('focus', () => select(index));
      piece.addEventListener('click', event => {
        select(index);
        if (mobile.matches || event.detail === 0 || event.pointerType === 'touch' || event.pointerType === 'pen') {
          setFace(piece, piece.dataset.face === 'back' ? 'front' : 'back');
        }
      });
    });
    stage.addEventListener('keydown', event => {
      let index;
      if (event.key === 'ArrowRight') index = selected + 1;
      else if (event.key === 'ArrowLeft') index = selected - 1;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = pieces.length - 1;
      else return;
      event.preventDefault();
      select(index);
      pieces[selected].focus({ preventScroll: true });
      if (mobile.matches) pieces[selected].scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduced.matches ? 'instant' : 'smooth' });
    });
    stage.addEventListener('scroll', () => {
      if (!mobile.matches) return;
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => {
        const viewport = stage.getBoundingClientRect();
        const center = viewport.left + viewport.width / 2;
        let closest = 0;
        let distance = Infinity;
        pieces.forEach((piece, index) => {
          const rect = piece.getBoundingClientRect();
          const delta = Math.abs(rect.left + rect.width / 2 - center);
          if (delta < distance) { closest = index; distance = delta; }
        });
        if (closest !== selected) select(closest, false);
      });
    }, { passive: true });
    root.dataset.initialized = 'true';
    select(0, false);
    mobile.addEventListener('change', () => {
      position();
      if (mobile.matches) stage.scrollTo({ left: pieces[selected].offsetLeft - (stage.clientWidth - pieces[selected].offsetWidth) / 2, behavior: 'instant' });
    });
    new ResizeObserver(position).observe(root);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["storage-sport-story"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-storage-sport]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const video = root.querySelector('video');
      const button = root.querySelector('[data-sport-toggle]');
      const label = root.querySelector('[data-sport-toggle-label]');
      const error = root.querySelector('[data-sport-error]');
      if (!video || !button || !label) return;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let userPaused = motion.matches;
      let visible = false;
      video.muted = true;
      video.controls = false;
      button.hidden = false;
      const update = () => {
        const playing = !video.paused && !video.ended;
        root.classList.toggle('is-playing', playing);
        const text = playing ? button.dataset.pauseLabel : button.dataset.playLabel;
        button.setAttribute('aria-label', text);
        button.setAttribute('aria-pressed', String(playing));
        label.textContent = text;
      };
      const play = () => {
        if (!visible || userPaused || document.hidden) return;
        const result = video.play();
        if (result) result.catch(update);
      };
      button.addEventListener('click', () => {
        if (video.paused) { userPaused = false; play(); }
        else { userPaused = true; video.pause(); }
      });
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      video.addEventListener('error', () => { button.hidden = true; if (error) error.hidden = false; });
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else play(); });
      motion.addEventListener('change', () => { if (motion.matches) { userPaused = true; video.pause(); } });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          visible = entries.some(entry => entry.isIntersecting);
          if (visible) play(); else video.pause();
        }, { threshold: .15 });
        observer.observe(video);
      } else { visible = true; play(); }
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
